import { MapperService } from "./mapper-services";
import { Injectable } from "@angular/core";
import { FinancialProductRequest, PartnerIdentifiers, Vehicle } from "../interfaces/financial-simulator/financial-product-request.interface";
import { Data } from "../interfaces/data/data.interface";

@Injectable({
    providedIn: 'root',
})
export class FinancialProductMapperService extends MapperService<Data, FinancialProductRequest>  {

    protected map(entity: Data): FinancialProductRequest {
        const fp: FinancialProductRequest = {
            typeOfUse: "PRIVATE",   //  No se guarda en CS (es obligatorio)??
            personType: "LEGAL",
            channel: 'ONLINE', //entity.financialData.channel, // POS por defecto?
            dealerPriceGrossAmount: entity.financialData.price || 0,
            dealerPriceNetAmount: entity.financialData.amountFinanced || 0,
            currencyCode: entity.financialData.currencyCode,
            vehicles: this.mapVehicles(entity),
            partnerIdentifiers: this.mapPartnerIdentifiers(entity)
        };
        return fp;
    }

    private mapVehicles(entity: Data): Vehicle[] {
        // Mock de datos de ejemplo para los vehículos
        return [
            {
                vin: entity.vehicleData.vin,
                vehicleType: 'CAR',//entity.vehicleData.type,
                model: entity.vehicleData.model,
                brand: entity.vehicleData.brand,
                version: entity.vehicleData.version,
                modelYear: entity.vehicleData.modelYear,
                firstRegistrationDate: entity.vehicleData.firstRegistrationDate,
                status: 'NEW',  //TODO Ask
                currentMileage: entity.vehicleData.mileage,
                currencyCode: entity.financialData.currencyCode,
                energy: 'PETROL',  //TODO Ask
                originalPriceGrossAmount: entity.financialData.installmentTotalGrossAmount,
                originalPriceNetAmount: null, //entity.financialData.installmentTotalGrossAmount / 1.21, //TODO Ask
                optionsTotalGrossAmount: 0,  //TODO Ask
                accessoriesTotalGrossAmount: 0,  //TODO Ask
                co2Emission: null,  //TODO Ask
                vehicleIdentifiers: [
                    {
                        sourceId: '5',
                        sourceName: entity.userData.agreement ? entity.userData.agreement : 'JLR',
                        vehicleId: entity.vehicleData.version
                    }
                ]
            }
        ];
    }

    private mapPartnerIdentifiers(entity: Data): PartnerIdentifiers {
        // Aquí puedes mapear los identificadores del partner si tienes esa información en FinancialProducts
        // Por ahora, devolvemos un objeto vacío
        return {
            partnerStoreId: entity.userData.store ? entity.userData.store : '',
            partnerSalesmanId: entity.userData.salesman ? entity.userData.salesman : '',
            partnerVendorId: entity.userData.agreement ? entity.userData.agreement : '',
        };
    }

    ////// MOCKS //////

    private mapVehiclesMocked(): Vehicle[] {
        // Mock de datos de ejemplo para los vehículos
        return [
            {
                vin: '1HGCM82633A004352',
                vehicleType: 'Car',
                model: 'Model S',
                brand: 'Tesla',
                version: 'Plaid',
                modelYear: 2023,
                firstRegistrationDate: '2023-01-01',
                status: 'Active',
                currentMileage: 10000,
                currencyCode: 'USD',
                energy: 'Electric',
                originalPriceGrossAmount: 100000,
                originalPriceNetAmount: 95000,
                optionsTotalGrossAmount: 5000,
                accessoriesTotalGrossAmount: 2000,
                co2Emission: 0,
                vehicleIdentifiers: [
                    {
                        sourceId: '12345',
                        sourceName: 'Dealer A',
                        vehicleId: 'V12345'
                    }
                ]
            }
        ];
    }

    private mapPartnerIdentifiersMocked(): PartnerIdentifiers {
        // Mock de datos de ejemplo para los identificadores del partner
        return {
            partnerStoreId: 'JAGUAR',
            partnerSalesmanId: 'R-HOBES',
            partnerVendorId: 'JAGUAR'
        };
    }

    ////// END MOCKS //////
}